export default "__VITE_PUBLIC_ASSET__d7e85f13__"